export default __webpack_public_path__ + "6186d215b4f34c2b96e719ac47550452.svg";